import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import apiRequest from "api/apiRequest";
import { UserContext } from "context/user";

const fetchBasePrice = async (token) => {
  const response = await apiRequest.get("v2/zoning/price", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const useBasePricing = () => {
  const { token } = useContext(UserContext);

  return useQuery(["zonePricing", token], () => fetchBasePrice(token));
};
